import {
    AccordionContainerDPC,
    AccordionDPC,
    CardHorizontalContainerDPC,
    CardHorizontalDPC,
    PageContainerDPC,
    SocialPanelContainerINR,
    LinkUtiliDPC,
    CardContainerDPC,
    PhotoVideoContainerAnticDPC,
    CarouselMinisitiDPC,
    CardDPC,
    AgendaDPC, SvgIconDPC
} from '@dpc-fe/shared';
import {graphql} from 'gatsby';
import React from 'react';
import {getSlug, getAccordionAndTabLinks} from "../functions/functions";
import {getAbstract} from "@dpc-fe/shared/js/shared-functions";
import moment from "moment";
import {prop, getCategoriaPrimariaEN} from "../functions/functions";

export default ({data}) => {
    const language = 'en';
    const primoPianoContenuto = data.node?.relationships?.field_primo_piano_contenuto;
    const primoPianoImage = primoPianoContenuto && primoPianoContenuto?.relationships?.field_immagine_anteprima ? primoPianoContenuto.relationships?.field_immagine_anteprima : null;
    const primoPianoStreaming = data.node?.relationships?.field_primo_piano_streaming;
    const box2 = [
        data.node?.relationships?.field_box_2_riga_1,
        data.node?.relationships?.field_box_2_riga_2,
        data.node?.relationships?.field_box_2_riga_3
    ];

    const inEvidenza = box2.flat().filter(Boolean);

    return (
      <PageContainerDPC
      menuItems={data.menu.edges}
      pageId={data.node?.drupal_internal__nid}
      title={data.node?.title}
      env={process.env.ENV}
      lang={language}
      basePathNavbar={process.env.MINISITO_IO_NON_RISCHIO_URL}
      immagineShare={data.node?.relationships?.field_immagine_dettaglio ? process.env.MINISITO_IO_NON_RISCHIO_URL + data.node.relationships?.field_immagine_dettaglio?.relationships?.image?.localFile?.publicURL: process.env.MINISITO_IO_NON_RISCHIO_URL + data.socialImg?.relationships?.image?.localFile?.publicURL}
      abstractShare={data.node?.body?.processed ? data.node.body.processed.replace(/<\/?[^>]+(>|$)/g, "") : ''}
      slug={process.env.MINISITO_IO_NON_RISCHIO_URL + '/' + language}
      minisiti={prop}
      menuFooterItems={data.menuFooter.edges}
      isIoNonRischio={true}
      isHomepage={true}
  >


    
      {data.node?.field_box_primo_piano_immagine && 
      <CardHorizontalContainerDPC titoloSezione={data.node.field_titolo_esteso}>
          <CardHorizontalDPC                  
              body={data.node.field_abstract ? data.node.field_abstract.processed : ''}
              image={data?.node?.relationships?.field_immagine_anteprima} 
              testoIntero={true}                   
          />
      </CardHorizontalContainerDPC> 
      }
      {(!data.node?.field_box_primo_piano_immagine && primoPianoContenuto && !data.node.field_streaming_homepage) &&
      <CardHorizontalContainerDPC titoloSezione={'Featured'}>
          <CardHorizontalDPC
              title={primoPianoContenuto.field_titolo_esteso}
              body={primoPianoContenuto.field_abstract ? primoPianoContenuto.field_abstract.value : ''}
              slug={getSlug(primoPianoContenuto.fields ? '/' + language + primoPianoContenuto.fields.slug : '', process.env.MINISITO_IO_NON_RISCHIO, primoPianoContenuto.relationships.field_sottodominio.name)}
              image={primoPianoImage}
              slugText={'Read more'}
          />
      </CardHorizontalContainerDPC>
      }

      {(!data.node?.field_box_primo_piano_immagine && primoPianoStreaming && data.node.field_streaming_homepage) &&
      <CardHorizontalContainerDPC titoloSezione={'Featured'}>
          <CardHorizontalDPC
              title={primoPianoStreaming.field_titolo}
              body={primoPianoStreaming.field_testo?.value}
              streaming={primoPianoStreaming}
          />
      </CardHorizontalContainerDPC>}

      {data.node?.relationships?.field_banner_inr &&
              <section className="container primo-piano">
              <div className="px-custom">
                <div className="row">
                  <div className="col-12">
                    <div className="fumetto-sec">
                      
                      <div>    		
                        <div className="fumetto-bnr">
                          <a href={getSlug(data.node?.relationships?.field_banner_inr.relationships?.field_link_interno?.fields ? '/' + language + data.node?.relationships?.field_banner_inr.relationships?.field_link_interno?.fields?.slug : '', process.env.MINISITO_IO_NON_RISCHIO, data.node?.relationships?.field_banner_inr.relationships?.field_link_interno?.relationships?.field_sottodominio?.name)} className="banner-inr">
                          <img src={data.node?.relationships?.field_banner_inr.relationships.field_immagine.relationships.image.localFile.publicURL} alt="Banner"/>
                          </a>
                        </div>
                      </div>
                  
                    </div>
                  </div>
                </div>
              </div>
            </section>

            }

          {Array.isArray(inEvidenza) && inEvidenza.length > 0 &&
            <CardContainerDPC titoloSezione={'Highlights'}>
            {inEvidenza.map(box => (             
                <div className="col-12 col-md-4">
                    <CardDPC
                        title={box.field_titolo_esteso}
                        body={box.field_abstract ? box.field_abstract.value : null}
                        slug={getSlug(box.fields ? '/' + language + box.fields.slug : '', process.env.MINISITO_IO_NON_RISCHIO, box.relationships?.field_sottodominio?.name)}
                        image={box.relationships?.field_immagine_dettaglio}
                        categoria={box.field_categoria_primaria ? box.field_categoria_primaria.replace('_', ' ') : ''}
                    />
                </div>
            ))
            }
            </CardContainerDPC>
            }


            

      {Array.isArray(data.node?.relationships?.field_pulsanti_neri) && 
        data.node?.relationships?.field_pulsanti_neri.reduce((acc, e, i) => (i %  Math.min(3, data.node?.relationships?.field_pulsanti_neri.length) ? acc[acc.length - 1].push(e) : acc.push([e]), acc), []).map(
          row => 
          <>
          <section className="container btn-block-uppercase-wrapper other-btn-hp">
              <div className="px-custom">
                  <div className="row mb-3">
                    {row.map(button =>
                      
                        <div className="col">
                        <a href={getSlug(button.relationships?.field_link_interno?.fields ? '/' + language + button.relationships?.field_link_interno?.fields?.slug : '', process.env.MINISITO_IO_NON_RISCHIO, button.relationships?.field_link_interno?.relationships?.field_sottodominio?.name)} className="btn btn-primary" role="button">
                            <img src={button.relationships?.field_immagine?.relationships?.image?.localFile?.publicURL} alt={button.relationships?.field_immagine?.field_alt} className="icon-shadow"/>
                            <img src={button.relationships?.field_immagine?.relationships?.image?.localFile?.publicURL} alt={button.relationships?.field_immagine?.field_alt}/>
                            <span>{button.field_titolo}</span></a>
                        </div>
                    )}                            
                  </div>
              </div>
          </section>
          </>
        )
      }

  {data.node?.field_titolo_sezione_btn_gialli &&
  <section className="container btn-block-uppercase-wrapper rischi-btn-hp">
    <h3>{data.node?.field_titolo_sezione_btn_gialli}</h3>
    <div className="px-custom">
    <div className="row">
    {Array.isArray(data.node?.relationships?.field_pulsanti_gialli) && 
        data.node?.relationships?.field_pulsanti_gialli.map(
          button => 
          <>                                   
                  
                    
                      
                        <div className="col">
                        <a href={getSlug(button.relationships?.field_link_interno?.fields ? '/' + language + button.relationships?.field_link_interno?.fields?.slug : '', process.env.MINISITO_IO_NON_RISCHIO, button.relationships?.field_link_interno?.relationships?.field_sottodominio?.name)} className="btn btn-rischi" role="button">
                            {/*<svg className="icon icon-sm icon-white">
                              <use xlinkHref={button.relationships?.field_immagine?.relationships?.image?.localFile?.publicURL}/>
                            </svg> */
                            <img className="icon icon-lg" src={button.relationships?.field_immagine?.relationships?.image?.localFile?.publicURL} alt={button.relationships?.field_immagine?.field_alt}/>
                            }                        
                            <span>{button.field_titolo}</span></a>
                        </div>
                                            
                  
                
          </>
        )
      }
      </div>
    </div>
  </section>}
  </PageContainerDPC>
    );
};

export const query = graphql`
{
  node: nodeHomepageMinisitoIoNonRischio(field_codice_lingua: { eq: true }) {
    title
    body {
      processed
    }
    fields {
      slug
    }
    field_abstract {
      value
      processed
    }
    field_streaming_homepage
    field_titolo_esteso
    field_data
    drupal_internal__nid
    field_id_contenuto_originale
    field_box_primo_piano_immagine
    field_titolo_sezione_btn_gialli
    relationships {
      field_banner_inr{
        field_titolo
        relationships{
          field_immagine{
            field_alt
            field_didascalia
            field_titolo_esteso
            relationships{
              image: field_immagine {
                localFile {
                  publicURL
                }
              }
            }
          }
          field_link_interno{
            
            ...pubblicazioneFragment
            ...notiziaFragment
            ...approfondimentoFragment
            ...normativaFragment
            ...pageFragment
            ...bandoDiGaraFragment
            ...comunicatoStampaFragment
            ...corsoFragment
            ...mappaFragment
            ...timelineFragment
            ...sezioneConAnticipazioniFragment
            ...sezioneSenzaAnticipazioniFragment
            ...elencoApprofondimentiFragment
            ...elencoGlossariFragment
            ...elencoAttualitaFragment
            ...elencoPodcastFragment
            ...elencoPubblicazioniFragment
            ...elencoNormativaFragment
            ...elencoBandiEContrattiFragment
            ...elencoFotoVideoFragment
...elencoWebinarFragment
            ...homepageVolontariatoFragment
            ...homepageRelazioniFragment
            ...homepageRischiFragment
            ...homepageNazionaleFragment
            ...homepageMappeFragment
            ...homepageGiovaniFragment
            ...homepageFormazioneFragment
            ...homepageEventiFragment
            ...homepageEmergenzeFragment
            ...homepageDocsFragment
            ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
...homepageIononrischioFragment
...homepageInrAttimoDecisivoFragment
            ...homepagePortaleFragment
            ...bollettinoCriticitaFragment
            ...bollettinoVigilanzaFragment
            ...sezioneAllertaMeteoIdroFragment
            ...galleriaFotoFragment
            ...galleriaFlickrFragment
            ...videoFragment
...webinarFragment
...videolezioniFragment
...elencoVideolezioniFragment
          }
        }
      }
      field_pulsanti_neri{
        field_titolo
        relationships{
          field_immagine{
            field_alt
            field_didascalia
            field_titolo_esteso
            relationships{
              image: field_immagine {
                localFile {
                  publicURL
                }
              }
            }
          }
          field_link_interno{
            
            ...pubblicazioneFragment
            ...notiziaFragment
            ...approfondimentoFragment
            ...normativaFragment
            ...pageFragment
            ...bandoDiGaraFragment
            ...comunicatoStampaFragment
            ...corsoFragment
            ...mappaFragment
            ...timelineFragment
            ...sezioneConAnticipazioniFragment
            ...sezioneSenzaAnticipazioniFragment
            ...elencoApprofondimentiFragment
            ...elencoGlossariFragment
            ...elencoAttualitaFragment
            ...elencoPodcastFragment
            ...elencoPubblicazioniFragment
            ...elencoNormativaFragment
            ...elencoBandiEContrattiFragment
            ...elencoFotoVideoFragment
...elencoWebinarFragment
            ...homepageVolontariatoFragment
            ...homepageRelazioniFragment
            ...homepageRischiFragment
            ...homepageNazionaleFragment
            ...homepageMappeFragment
            ...homepageGiovaniFragment
            ...homepageFormazioneFragment
            ...homepageEventiFragment
            ...homepageEmergenzeFragment
            ...homepageDocsFragment
            ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
...homepageIononrischioFragment
...homepageInrAttimoDecisivoFragment
            ...homepagePortaleFragment
            ...bollettinoCriticitaFragment
            ...bollettinoVigilanzaFragment
            ...sezioneAllertaMeteoIdroFragment
            ...galleriaFotoFragment
            ...galleriaFlickrFragment
            ...videoFragment
...webinarFragment
...videolezioniFragment
...elencoVideolezioniFragment
          }
        }
      }
      field_pulsanti_gialli{
        field_titolo
        relationships{
          field_immagine{
            field_alt
            field_didascalia
            field_titolo_esteso
            relationships{
              image: field_immagine {
                localFile {
                  publicURL
                }
              }
            }
          }
          field_link_interno{
            
            ...pubblicazioneFragment
            ...notiziaFragment
            ...approfondimentoFragment
            ...normativaFragment
            ...pageFragment
            ...bandoDiGaraFragment
            ...comunicatoStampaFragment
            ...corsoFragment
            ...mappaFragment
            ...timelineFragment
            ...sezioneConAnticipazioniFragment
            ...sezioneSenzaAnticipazioniFragment
            ...elencoApprofondimentiFragment
            ...elencoGlossariFragment
            ...elencoAttualitaFragment
            ...elencoPodcastFragment
            ...elencoPubblicazioniFragment
            ...elencoNormativaFragment
            ...elencoBandiEContrattiFragment
            ...elencoFotoVideoFragment
...elencoWebinarFragment
            ...homepageVolontariatoFragment
            ...homepageRelazioniFragment
            ...homepageRischiFragment
            ...homepageNazionaleFragment
            ...homepageMappeFragment
            ...homepageGiovaniFragment
            ...homepageFormazioneFragment
            ...homepageEventiFragment
            ...homepageEmergenzeFragment
            ...homepageDocsFragment
            ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
...homepageIononrischioFragment
...homepageInrAttimoDecisivoFragment
            ...homepagePortaleFragment
            ...bollettinoCriticitaFragment
            ...bollettinoVigilanzaFragment
            ...sezioneAllertaMeteoIdroFragment
            ...galleriaFotoFragment
            ...galleriaFlickrFragment
            ...videoFragment
...webinarFragment
...videolezioniFragment
...elencoVideolezioniFragment
          }
        }
      }
      field_immagine_dettaglio {
        field_alt
        field_didascalia
        field_titolo_esteso
        relationships {
          image: field_immagine {
            localFile {
              publicURL
              childImageSharp {
                fluid(maxWidth: 1100) {
                  ...GatsbyImageSharpFluid_noBase64
                }
              }
            }
          }
        }
      }
      field_immagine_anteprima {
        field_alt
        field_didascalia
        relationships {
          image: field_immagine {
            localFile {
              publicURL
              childImageSharp {
                fluid(maxWidth: 1100) {
                  ...GatsbyImageSharpFluid_noBase64
                }
              }
            }
          }
        }
      }
      field_sottodominio {
        name
      }
      field_riferimento_traduzione {
        fields {
          slug
        }
      }
      field_box_2_riga_1 {
        ...pubblicazioneFragment
        ...notiziaFragment
        ...approfondimentoFragment
        ...normativaFragment
        ...pageFragment
        ...bandoDiGaraFragment
        ...comunicatoStampaFragment
        ...corsoFragment
        ...mappaFragment
        ...timelineFragment
        ...sezioneConAnticipazioniFragment
        ...sezioneSenzaAnticipazioniFragment
        ...elencoApprofondimentiFragment
        ...elencoGlossariFragment
        ...elencoAttualitaFragment
        ...elencoPodcastFragment
        ...elencoPubblicazioniFragment
        ...elencoNormativaFragment
        ...elencoBandiEContrattiFragment
        ...elencoFotoVideoFragment
...elencoWebinarFragment
        ...homepageVolontariatoFragment
        ...homepageRelazioniFragment
        ...homepageRischiFragment
        ...homepageNazionaleFragment
        ...homepageMappeFragment
        ...homepageGiovaniFragment
        ...homepageFormazioneFragment
        ...homepageEventiFragment
        ...homepageEmergenzeFragment
        ...homepageDocsFragment
        ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
...homepageIononrischioFragment
...homepageInrAttimoDecisivoFragment
        ...homepagePortaleFragment
        ...bollettinoCriticitaFragment
        ...bollettinoVigilanzaFragment
        ...sezioneAllertaMeteoIdroFragment
        ...galleriaFotoFragment
        ...galleriaFlickrFragment
        ...videoFragment
...webinarFragment
...videolezioniFragment
...elencoVideolezioniFragment
      }
      field_box_2_riga_2 {
        ...pubblicazioneFragment
        ...notiziaFragment
        ...approfondimentoFragment
        ...normativaFragment
        ...pageFragment
        ...bandoDiGaraFragment
        ...comunicatoStampaFragment
        ...corsoFragment
        ...mappaFragment
        ...timelineFragment
        ...sezioneConAnticipazioniFragment
        ...sezioneSenzaAnticipazioniFragment
        ...elencoApprofondimentiFragment
        ...elencoGlossariFragment
        ...elencoAttualitaFragment
        ...elencoPodcastFragment
        ...elencoPubblicazioniFragment
        ...elencoNormativaFragment
        ...elencoBandiEContrattiFragment
        ...elencoFotoVideoFragment
...elencoWebinarFragment
        ...homepageVolontariatoFragment
        ...homepageRelazioniFragment
        ...homepageRischiFragment
        ...homepageNazionaleFragment
        ...homepageMappeFragment
        ...homepageGiovaniFragment
        ...homepageFormazioneFragment
        ...homepageEventiFragment
        ...homepageEmergenzeFragment
        ...homepageDocsFragment
        ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
...homepageIononrischioFragment
...homepageInrAttimoDecisivoFragment
        ...homepagePortaleFragment
        ...bollettinoCriticitaFragment
        ...bollettinoVigilanzaFragment
        ...sezioneAllertaMeteoIdroFragment
        ...galleriaFotoFragment
        ...galleriaFlickrFragment
        ...videoFragment
...webinarFragment
...videolezioniFragment
...elencoVideolezioniFragment
      }
      field_box_2_riga_3 {
        ...pubblicazioneFragment
        ...notiziaFragment
        ...approfondimentoFragment
        ...normativaFragment
        ...pageFragment
        ...bandoDiGaraFragment
        ...comunicatoStampaFragment
        ...corsoFragment
        ...mappaFragment
        ...timelineFragment
        ...sezioneConAnticipazioniFragment
        ...sezioneSenzaAnticipazioniFragment
        ...elencoApprofondimentiFragment
        ...elencoGlossariFragment
        ...elencoAttualitaFragment
        ...elencoPodcastFragment
        ...elencoPubblicazioniFragment
        ...elencoNormativaFragment
        ...elencoBandiEContrattiFragment
        ...elencoFotoVideoFragment
...elencoWebinarFragment
        ...homepageVolontariatoFragment
        ...homepageRelazioniFragment
        ...homepageRischiFragment
        ...homepageNazionaleFragment
        ...homepageMappeFragment
        ...homepageGiovaniFragment
        ...homepageFormazioneFragment
        ...homepageEventiFragment
        ...homepageEmergenzeFragment
        ...homepageDocsFragment
        ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
...homepageIononrischioFragment
...homepageInrAttimoDecisivoFragment
        ...homepagePortaleFragment
        ...bollettinoCriticitaFragment
        ...bollettinoVigilanzaFragment
        ...sezioneAllertaMeteoIdroFragment
        ...galleriaFotoFragment
        ...galleriaFlickrFragment
        ...videoFragment
...webinarFragment
...videolezioniFragment
...elencoVideolezioniFragment
      }
      field_primo_piano_contenuto {
        ...pubblicazioneFragment
        ...notiziaFragment
        ...approfondimentoFragment
        ...normativaFragment
        ...pageFragment
        ...bandoDiGaraFragment
        ...comunicatoStampaFragment
        ...corsoFragment
        ...mappaFragment
        ...timelineFragment
        ...sezioneConAnticipazioniFragment
        ...sezioneSenzaAnticipazioniFragment
        ...elencoApprofondimentiFragment
        ...elencoGlossariFragment
        ...elencoAttualitaFragment
        ...elencoPodcastFragment
        ...elencoPubblicazioniFragment
        ...elencoNormativaFragment
        ...elencoBandiEContrattiFragment
        ...elencoFotoVideoFragment
...elencoWebinarFragment
        ...homepageVolontariatoFragment
        ...homepageRelazioniFragment
        ...homepageRischiFragment
        ...homepageNazionaleFragment
        ...homepageMappeFragment
        ...homepageGiovaniFragment
        ...homepageFormazioneFragment
        ...homepageEventiFragment
        ...homepageEmergenzeFragment
        ...homepageDocsFragment
        ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
...homepageIononrischioFragment
...homepageInrAttimoDecisivoFragment
        ...homepagePortaleFragment
        ...bollettinoCriticitaFragment
        ...bollettinoVigilanzaFragment
        ...sezioneAllertaMeteoIdroFragment
        ...galleriaFotoFragment
        ...galleriaFlickrFragment
        ...videoFragment
...webinarFragment
...videolezioniFragment
...elencoVideolezioniFragment
      }
      field_primo_piano_streaming {
        field_testo {
          value
        }
        field_link {
          uri
          title
        }
        field_titolo
      }
    }
  }
  menu: allTaxonomyTermMenuIoNonRischioEn {
    edges {
      node {
        name
        weight
        field_check_superheader
        relationships {
          field_link_menu {
            ... on node__elenco_videolezioni {
              fields {
                slug
              }
              drupal_internal__nid
          }
            ... on node__pubblicazione {
              fields {
                slug
              }
              drupal_internal__nid
          }
            ... on node__timeline {
              fields {
                slug
              }
              drupal_internal__nid
          }
            ... on node__elenco_webinar {
              fields {
                slug
              }
              drupal_internal__nid
          }
            ... on node__mappa {
              fields {
                slug
              }
              drupal_internal__nid
          }
              ... on node__approfondimento {
                  fields {
                    slug
                  }
                  drupal_internal__nid
              }
              ... on node__notizia {
                  fields {
                    slug
                  }
                  drupal_internal__nid
              }
              ... on node__page {
                  fields {
                    slug
                  }
                  drupal_internal__nid
              }
              ... on node__sezione_senza_anticipazioni {
                  fields {
                      slug
                  }
                  drupal_internal__nid
              }
              ... on node__sezione_con_anticipazioni {
                  fields {
                      slug
                  }
                  drupal_internal__nid
              }
              ... on node__elenco_approfondimenti {
                fields {
                    slug
                }
                drupal_internal__nid
            }
              ... on node__elenco_approfondimenti_rischi {
                  fields {
                      slug
                  }
                  drupal_internal__nid
              }
              ... on node__elenco_podcast {
                  fields {
                      slug
                  }
                  drupal_internal__nid
              }
              ... on node__elenco_notizie_comunicati_stampa {
                  fields {
                      slug
                  }
                  drupal_internal__nid
              }
              ... on node__elenco_glossario {
                  fields {
                      slug
                  }
                  drupal_internal__nid
              }
              ... on node__elenco_pubblicazioni {
                  fields {
                      slug
                  }
                  drupal_internal__nid
              }
              ... on node__elenco_normative {
                  fields {
                      slug
                  }
                  drupal_internal__nid
              }
              ... on node__elenco_bandi_di_gara_e_contratti {
                  fields {
                      slug
                  }
                  drupal_internal__nid
              }
              ... on node__sezione_allerta_meteo_idro {
                  fields {
                      slug
                  }
                  drupal_internal__nid
              }
              ... on node__elenco_foto_e_video {
                  fields {
                      slug
                  }
                  drupal_internal__nid
              }
              ... on node__homepage_minisito_volontariato {
                 fields {
                      slug
                 }
                 relationships {
                      field_sottodominio {
                          name
                      }
                 }
                  drupal_internal__nid
              }
              ... on node__homepage_minisito_rischi {
                 fields {
                      slug
                 }
                 relationships {
                      field_sottodominio {
                          name
                      }
                 }
                  drupal_internal__nid
              }
              ... on node__homepage_minisito_ser_nazionale {
                  fields {
                          slug
                     }
                     relationships {
                          field_sottodominio {
                              name
                          }
                     }
                     drupal_internal__nid
              }
              ... on node__homepage_minisito_relazioni {
                  fields {
                          slug
                     }
                     relationships {
                          field_sottodominio {
                              name
                          }
                     }
                     drupal_internal__nid
              }
              ... on node__homepage_minisito_mappe {
                 fields {
                      slug
                 }
                 relationships {
                      field_sottodominio {
                          name
                      }
                 }
                 drupal_internal__nid
              }
              ... on node__homepage_minisito_scuola_giovani {
                 fields {
                      slug
                 }
                 relationships {
                      field_sottodominio {
                          name
                      }
                 }
                 drupal_internal__nid
              }
              ... on node__homepage_minisito_formazione {
                 fields {
                      slug
                 }
                 relationships {
                      field_sottodominio {
                          name
                      }
                 }
                 drupal_internal__nid
              }
              ... on node__homepage_minisito_eventi {
                 fields {
                      slug
                 }
                 relationships {
                      field_sottodominio {
                          name
                      }
                 }
                 drupal_internal__nid
              }
              ... on node__homepage_minisito_emergenze {
                 fields {
                      slug
                 }
                 relationships {
                      field_sottodominio {
                          name
                      }
                 }
                 drupal_internal__nid
              }
              ... on node__homepage_minisito_domande {
                 fields {
                      slug
                 }
                 relationships {
                      field_sottodominio {
                          name
                      }
                 }
                 drupal_internal__nid
              }
              ... on node__homepage_minisito_docs {
                 fields {
                      slug
                 }
                 relationships {
                      field_sottodominio {
                          name
                      }
                 }
                 drupal_internal__nid
              }
              ... on node__homepage_minisito_pnrr {
                  fields {
                       slug
                  }
                  relationships {
                       field_sottodominio {
                           name
                       }
                  }
                  drupal_internal__nid
               }
              ... on node__homepage_minisito_it_alert {
                  fields {
                       slug
                  }
                  relationships {
                       field_sottodominio {
                           name
                       }
                  }
                  drupal_internal__nid
               }
          }
          parent {
            name
            drupal_internal__tid
          }
        }
        drupal_internal__tid
      }
    }
  }
  eventi: allNodeEventi(
    filter: {
      field_codice_lingua: {eq: true}, relationships: { field_sottodominio: { name: { eq: "Io Non Rischio" } } }
    }
  ) {
    edges {
      node {
        body {
          processed
        }
        field_link {
          title
          uri
        }
        relationships {
          field_link_interno {
            ...pubblicazioneFragment
            ...notiziaFragment
            ...approfondimentoFragment
            ...normativaFragment
            ...pageFragment
            ...bandoDiGaraFragment
            ...comunicatoStampaFragment
            ...corsoFragment
            ...mappaFragment
            ...timelineFragment
            ...sezioneConAnticipazioniFragment
            ...sezioneSenzaAnticipazioniFragment
            ...elencoApprofondimentiFragment
            ...elencoGlossariFragment
            ...elencoAttualitaFragment
            ...elencoPodcastFragment
            ...elencoPubblicazioniFragment
            ...elencoNormativaFragment
            ...elencoBandiEContrattiFragment
            ...elencoFotoVideoFragment
...elencoWebinarFragment
            ...homepageVolontariatoFragment
            ...homepageRelazioniFragment
            ...homepageRischiFragment
            ...homepageNazionaleFragment
            ...homepageMappeFragment
            ...homepageGiovaniFragment
            ...homepageFormazioneFragment
            ...homepageEventiFragment
            ...homepageEmergenzeFragment
            ...homepageDocsFragment
            ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
...homepageIononrischioFragment
...homepageInrAttimoDecisivoFragment
            ...homepagePortaleFragment
            ...bollettinoCriticitaFragment
            ...bollettinoVigilanzaFragment
            ...sezioneAllertaMeteoIdroFragment
            ...galleriaFotoFragment
            ...galleriaFlickrFragment
            ...videoFragment
...webinarFragment
...videolezioniFragment
...elencoVideolezioniFragment
          }
          field_allegati {
            title
            field_titolo_esteso
            relationships {
              field_sottodominio {
                name
              }
              field_allegato {
                filesize
                filename
                localFile {
                  publicURL
                  extension
                }
              }
            }
          }
        }
        field_link_esterno
                field_data_evento
                title
        field_titolo_esteso
        field_luogo
      }
    }
  },
  menuFooter: allTaxonomyTermMenuFooterIoNonRischioEn {
          edges {
            node {
              name
              weight
              relationships {
                field_link_menu {
                    ... on node__approfondimento {
                        fields {
                          slug
                        }
                        drupal_internal__nid
                    }
                    ... on node__page {
                        fields {
                          slug
                        }
                        drupal_internal__nid
                    }
                    ... on node__elenco_glossario {
                        fields {
                            slug
                        }
                        drupal_internal__nid
                    }
                }
              }
              drupal_internal__tid
            }
          }
        },
        socialImg: nodeImmagine(title: {eq: "Placeholder social INR"}){
            relationships {
                image:field_immagine {
                  localFile {
                    publicURL
                  }
                }
            }
        }
}
`;
